export default {

    isOpera() {
        let retVal = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
        return retVal ? retVal : false;
    },

    isFirefox() {
        let retVal = typeof InstallTrigger !== 'undefined';
        return retVal ? retVal : false;
    },

    isSafari() {
        let retVal =  /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
        return retVal ? retVal : false;
    },

    isIE() {
        let retVal = /*@cc_on!@*/false || !!document.documentMode;
        return retVal ? retVal : false;
    },

    isEdge() {
        let retVal = !this.isIE() && !!window.StyleMedia;
        return retVal ? retVal : false;
    },

    isChrome() {
        let retVal = !this.isOpera() && !this.isEdge() && !!window.chrome && navigator.userAgent.indexOf('hrome/') >= 0;
        return retVal ? retVal : false;
    }
    //,

    // does not work anymore
    // isBlink() {
    //     let retVal = (this.isChrome() || this.isOpera()) && !!window.CSS;
    //     return retVal ? retVal : false;
    // }
}